import React, { useEffect, useState } from "react";

const LINES = [
  { text: "Unify Your Health.", gradient: false },
  { text: "Understand Your Body.", gradient: false },
  { text: "Optimize Your Life.", gradient: true },
];

/**
 * Cross-fades through the three headline lines continuously.
 * One line visible at a time. ~2.4s per line with a 700ms cross-fade.
 */
export const HeadlineFader = ({ className = "", testId, holdMs = 2200, fadeMs = 700 }) => {
  const [idx, setIdx] = useState(0);
  const [phase, setPhase] = useState("in"); // "in" | "out"

  useEffect(() => {
    let cycle;
    const tick = () => {
      setPhase("out");
      setTimeout(() => {
        setIdx((i) => (i + 1) % LINES.length);
        setPhase("in");
      }, fadeMs);
    };
    cycle = setInterval(tick, holdMs + fadeMs);
    return () => clearInterval(cycle);
  }, [holdMs, fadeMs]);

  const line = LINES[idx];

  return (
    <h1
      data-testid={testId}
      className={`relative font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.1] ${className}`}
      aria-label={LINES.map((l) => l.text).join(" ")}
    >
      {/* Ghost line to lock height across all three texts (no layout jump) */}
      <span aria-hidden="true" className="block invisible">
        {LINES.reduce((a, b) => (a.text.length > b.text.length ? a : b)).text}
      </span>
      <span
        key={idx}
        className={`absolute inset-0 flex items-center justify-center transition-opacity ease-in-out ${
          phase === "in" ? "opacity-100" : "opacity-0"
        } ${line.gradient ? "bg-gradient-to-r from-[#22B6B0] to-[#7A5BFF] bg-clip-text text-transparent" : "text-slate-900"}`}
        style={{ transitionDuration: `${fadeMs}ms` }}
      >
        {line.text}
      </span>
    </h1>
  );
};

export default HeadlineFader;
